import { combineEpics } from 'redux-observable';

import { _reducer } from './AccountSettings.reducers';
import _epics from './AccountSettings.epics';

export const epics = combineEpics(_epics);

export { _reducer };
export * from './AccountSettings.actions';
